import React, { useContext } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { SubmitFormContext } from '../../../context';
import FilePreview from '../FilePreview';
import MultiFilePreview from '../MultiFilePreview';

interface Props {
  className?: string;
}

const ReplaceableFilePreview: React.FC<Props> = props => {
  const { initResponse } = useContext(SubmitFormContext)!;
  const isMultiVideo = useFlag('multi_video');
  const deviation = initResponse?.deviation;
  const useMultiMediaLayout = isMultiVideo ? !!deviation?.canBeMultiMedia : false;

  if (useMultiMediaLayout) {
    return <MultiFilePreview {...props} />;
  }

  return <FilePreview {...props} />;
};
ReplaceableFilePreview.displayName = 'ReplaceableFilePreview';

export default ReplaceableFilePreview;
